import React from 'react'
import Brand from '@components/brand'
import MainLayout from '@layouts/main-layout'

const BrandPage = () => {
  return (
    <>
      <Brand />
    </>
  )
}

BrandPage.getLayout = (page: React.ReactElement) => {
  return <MainLayout>{page}</MainLayout>
}

export default BrandPage
